import React, {useEffect} from 'react';
import Modal from "react-bootstrap/Modal";
import {Button, ButtonGroup} from "react-bootstrap";
import {getCandleFromDate, parsePrice, saveOpenedCurrency, isRelativeTPValue } from "../../utils/utils";
import LiquidityCatchTradeForm from "./forms/LiquidityCatchTradeForm";
import TPSLTradeForm from "./forms/TPSLTradeForm";
import UnifiedTradeForm from "./forms/UnifiedTradeForm";
import { normalizeEntryProtectionMode } from "../../trades/tradeUtils";

function TradePopup(props) {

    const [currency, setCurrency] = React.useState(null);
    const [tradeSide, setTradeSide] = React.useState(null);
    const [priceBy, setPriceBy] = React.useState(null);
    const [candle, setCandle] = React.useState(null);
    const [price, setPrice] = React.useState(null);
    const interval = props.tradeData?.candle || props.tradeData?.interval || props.chartTimeframe;
    const [volume, setVolume] = React.useState(50);
    const [leverage, setLeverage] = React.useState(5);
    const [stopLoss, setStopLoss] = React.useState(null);
    const [takeProfit, setTakeProfit] = React.useState(null);
    const [takeProfit2, setTakeProfit2] = React.useState(null);
    const [expiresIn, setExpiresIn] = React.useState(null);
    const [entryProtectionMode, setEntryProtectionMode] = React.useState("OFF");
    const [comment, setComment] = React.useState("");
    const [workflowMode, setWorkflowMode] = React.useState(
        () => localStorage.getItem("tradeWorkflowMode") || "TRADE"
    );

    const handleExpiresInChange = (expIn) => {
        setExpiresIn(expIn);
    }

    const handleVolumeChange = (vol) => {
        setVolume(vol);
        saveToLocalStorage('volume', vol);
    }

    const handleLeverageChange = (lev) => {
        setLeverage(lev);
        saveToLocalStorage('leverage', lev);
    }

    const setSL = (val) => {
        setStopLoss(val);
        saveToLocalStorage("stopLoss", val);
    }

    const setTP = (val, isSecond) => {

        const key = isSecond ? "takeProfit2" : "takeProfit";

        const setters = {
            takeProfit: setTakeProfit,
            takeProfit2: setTakeProfit2
        };

        setters[key](val);

        if (isRelativeTPValue(tradeSide, val)) {
            saveToLocalStorage(key, val);
        }
    }

    useEffect(() => {

        const tradeData = JSON.parse(localStorage.getItem("tradeData")) || {};
        
        setCurrency(props.tradeData?.currency);
        setTradeSide(props.tradeData?.tradeSide);
        const popupValue = (key, fallback) => (
            props.tradeData && props.tradeData[key] !== undefined ? props.tradeData[key] : fallback
        );

        setVolume(popupValue("volume", tradeData.volume || 50));
        setLeverage(popupValue("leverage", tradeData.leverage || 5));
        setStopLoss(popupValue("stopLoss", tradeData.stopLoss || null));
        setTakeProfit(popupValue("takeProfit", tradeData.takeProfit || null));
        setTakeProfit2(popupValue("takeProfit2", tradeData.takeProfit2 || null));
        setEntryProtectionMode(normalizeEntryProtectionMode(
            popupValue("entryProtectionMode", tradeData.entryProtectionMode),
            popupValue("protectEntry", Boolean(tradeData.protectEntry))
        ));
        setComment(popupValue("comment", tradeData.comment || ""));

        setPriceBy(props.priceBy);

        if (props.tradeData.price !== undefined && props.tradeData.price !== null) {
            setPrice(parsePrice(props.tradeData.price));
        }

        if (props.tradeData.date) {
            const formattedCandle = getCandleFromDate(props.tradeData.date);
            setCandle(formattedCandle);
        }

    }, [props.tradeData, props.priceBy]);


    useEffect(() => {
        if (props.show && props.tradeData?.currency) {
            saveOpenedCurrency(props.tradeData?.currency);
        }
    }, [props.show, props.tradeData?.currency]);

    const saveToLocalStorage = (attr, val) => {
        let tradeData = JSON.parse(localStorage.getItem("tradeData")) || {};
        localStorage.setItem("tradeData", JSON.stringify({
            ...tradeData,
            [attr]: val
        }));
    }


    const handleSubmit = (command) => {
        props.onCommand(command);
    }

    const handleEntryProtectionModeChange = (mode) => {
        setEntryProtectionMode(mode);
        saveToLocalStorage("entryProtectionMode", mode);
    }

    const handleWorkflowChange = (mode) => {
        setWorkflowMode(mode);
        localStorage.setItem("tradeWorkflowMode", mode);
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="custom-modal-width custom-modal-height">

            <Modal.Body className="bg-dark d-flex align-items-center justify-content-center w-100 row">
                <div className="col-md-4"></div>
                <div className="col-md-4">
                    {priceBy !== "TPSL" &&
                        <div className="pt-2 pb-2 details">
                            <ButtonGroup className="w-100" aria-label="Trade workflow">
                                {[["TRADE", "Trade"], ["CATCH", "Catch"]].map(([mode, label]) => (
                                    <Button
                                        key={mode}
                                        variant={mode === workflowMode ? "primary" : "secondary"}
                                        onClick={() => handleWorkflowChange(mode)}>
                                        {label}
                                    </Button>
                                ))}
                            </ButtonGroup>
                        </div>
                    }

                    {workflowMode === "TRADE" && priceBy !== "TPSL" &&
                        <UnifiedTradeForm
                            /* props */
                            tradeData={props.tradeData}
                            currency={currency}
                            tradeSide={tradeSide}
                            volume={volume}
                            candle={candle}
                            leverage={leverage}
                            price={price}
                            interval={interval}
                            stopLoss={stopLoss}
                            takeProfit={takeProfit}
                            takeProfit2={takeProfit2}
                            expiresIn={expiresIn}
                            entryProtectionMode={entryProtectionMode}
                            comment={comment}
                            draw={props.draw}
                            setBtnDisabled={props.setBtnDisabled}
                            /* input changes */
                            setTradeSide={(ts) => setTradeSide(ts)}
                            setVolume={(vol) => handleVolumeChange(vol)}
                            setLeverage={(lev) => handleLeverageChange(lev)}
                            setPrice={(prc) => setPrice(prc)}
                            setStopLoss={(sl) => setSL(sl)}
                            setTakeProfit={(tp) => setTP(tp, false)}
                            setTakeProfit2={(tp) => setTP(tp, true)}
                            setExpiresIn={(expIn) => handleExpiresInChange(expIn)}
                            setEntryProtectionMode={handleEntryProtectionModeChange}
                            setComment={(value) => setComment(value)}
                            handleSubmit={(command) => handleSubmit(command)}
                        />
                    }

                    {workflowMode === "CATCH" && priceBy !== "TPSL" &&
                        <LiquidityCatchTradeForm
                            tradeData={props.tradeData}
                            currency={currency}
                            tradeSide={tradeSide}
                            interval={interval}
                            volume={volume}
                            leverage={leverage}
                            price={price}
                            candle={candle}
                            draw={props.draw}
                            setBtnDisabled={props.setBtnDisabled}
                            setTradeSide={(side) => setTradeSide(side)}
                            setVolume={(value) => handleVolumeChange(value)}
                            setLeverage={(value) => handleLeverageChange(value)}
                            setPrice={(value) => setPrice(value)}
                            handleSubmit={(command) => handleSubmit(command)}
                        />
                    }

                    {priceBy === "TPSL" &&
                        <TPSLTradeForm
                            /* props */
                            currency={currency}
                            tradeSide={tradeSide}
                            interval={interval}
                            candle={candle}
                            price={price}
                            draw={props.draw}
                            setBtnDisabled={props.setBtnDisabled}
                            /* input changes */
                            setTradeSide={(ts) => setTradeSide(ts)}
                            setPrice={(prc) => setPrice(prc)}
                            handleSubmit={(command) => handleSubmit(command)}
                        />
                    }
                </div>
                <div className="col-md-4"></div>
            </Modal.Body>
            <Modal.Footer className="bg-dark">
                <Button
                    //disabled={props.btnDisabled}
                    onClick={props.onClose}
                    variant={"primary"}>Close</Button>
            </Modal.Footer>
        </Modal>
);
}

export default TradePopup;
